import { render, staticRenderFns } from "./GenericButtonDownload.vue?vue&type=template&id=f3629dfe&scoped=true"
import script from "./GenericButtonDownload.vue?vue&type=script&lang=js"
export * from "./GenericButtonDownload.vue?vue&type=script&lang=js"
import style0 from "./GenericButtonDownload.vue?vue&type=style&index=0&id=f3629dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3629dfe",
  null
  
)

export default component.exports